import React, { ReactNode } from 'react';

interface BackgroundProps {
  children: ReactNode;
  image?: string;
  className?: string;
}

const Background: React.FC<BackgroundProps> = ({ 
  children,
  image = "/screenshots/slide1.png",
  className = '' 
}) => {
  return (
    <div 
      className={`min-h-screen bg-cover bg-center bg-no-repeat ${className}`}
      style={{
        backgroundImage: `url(${image})`
      }}
    >
      {children}
    </div>
  );
};

export default Background;